import { onSignupSuccess } from '../on-signup-success';
import { waitAndReload } from '../redirects';
import { FacebookSignupHelper } from './facebook-signup-helper';

interface Params {
  $wrapper: JQuery<HTMLElement>;
  $login: JQuery<HTMLElement>;
  $errorContainer: JQuery<HTMLElement>;
  redirectUrl?: string;
}

// FB Login
export function init(params: Params) {
  const { $wrapper, $login, $errorContainer, redirectUrl } = params;
  $wrapper.on('click', function (evt) {
    const $target = $(evt.currentTarget);
    if ($target.hasClass('disabled')) {
      return false;
    }
    const fb_expected_event =
      $(this).attr('id') == 'fb-signup-img' ? 'signup' : 'login';
    $target.addClass('disabled');
    FB.login(
      (resp) => {
        const fb_signup_helper = new FacebookSignupHelper(
          resp,
          fb_expected_event
        );
        const signup_promise = fb_signup_helper.submit();
        signup_promise.done((data) => {
          $target.removeClass('disabled');
          if (data.actual_event_type === 'signup') {
            onSignupSuccess(
              data.server_data.customer.id,
              redirectUrl,
              data.server_data.customer,
              'facebook'
            );
          } else {
            waitAndReload();
          }
        });
        signup_promise.fail(() => {
          $errorContainer.show();
          $login.find('.dialog').effect('shake', { times: 3, displace: 10 });
        });
        signup_promise.always(() => {
          $target.removeClass('disabled');
        });
      },
      { scope: 'public_profile,email', return_scopes: true }
    );
  });
}
